<template>
  <div id="app">
    <el-row>
      <el-col :span="20">
Passo 1 - PROPOSTA COMERCIAL

      </el-col>
    </el-row>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" >
       <el-form-item label="Proposta Comercial" prop="proposta">
        <vue-editor id="proposta" v-model="ruleForm.proposta"></vue-editor>
      </el-form-item>
        <el-form-item label="Supervisor Comercial" prop="comercial">
          <el-input type="textarea" v-model="ruleForm.comercial"></el-input>
        </el-form-item>
        <el-form-item label="Responsável Técnico" prop="tecnico">
          <el-input type="textarea" v-model="ruleForm.tecnico"></el-input>
        </el-form-item>    
    </el-form>
    
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
   components: {
    VueEditor,
  },
   data() {
    return {
       ruleForm: {
        proposta: "<h1 style='text-align:center;'>PROPOSTA COMERCIAL</h1><h2 style='text-align:center;'>Referente ao fornecimento de quadro de comando.</h2><br><p>Agradecemos a oportunidade, e nos mantemos a disposição para quaisquer esclarecimentos, alterações e negociações.</p>",
        comercial:'',
        tecnico:'',
       },
    };

  },

  methods: {
  
    }
};
</script>

<style>
#proposta  {
  height: 350px;
  width: 1024px;
}
</style>

